// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 60 ? "dice-box" : chunkId) + "." + {"60":"418461c4","665":"66ae9bb2","787":"d5fa4d18","854":"dbd690f7"}[chunkId] + ".chunk.js";
};